import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getRunRateAnalysis';

export const getRunRateAnalysis = (params) => {
    return network.post(ENDPOINT, params).then((response) => response.data);
};
